import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';


import * as projectApi from '../../api/project-api';

import store from '../../../store';
import { propsRecievedProjectPage } from '../../actions/project-actions';

import SlickSlider from '../../components/slick-slider/index'

import { browserHistory } from 'react-router'

import LazyLoad from 'react-lazy-load'



import './projectPage.css';

class ProjectPage extends Component {
  constructor(props) {
    super()
    this.props = props
    this.state = {
      currentProps: false
    }
  }

  componentDidMount() {
    let projectSlug = this.props.params.projectSlug
    projectApi.getProjects(projectSlug)
  }

  componentWillReceiveProps(nextProps){
    if(this.props !== nextProps) {
      this.setState({currentProps:true})
    }
  }

  randomNum = () => {
    return Math.random();
  }

  render() {
    if (this.state.currentProps === true) {
      return (
        <div>
          <Helmet
          title={this.props.project.title.rendered}
          meta={[
            {property: "og:title", content: `KK OBI - ${this.props.project.title.rendered}`},
            {property: "og:image", content: this.props.project.acf.featured_image.url }
          ]}/>
          <div><button className="project-back" onClick={browserHistory.goBack}>Back</button></div>
          <div className="image--slickSlider-wrapper">
          {
            this.props.project.acf.gallery.map(function(asset) {
              if(asset.type === 'image') {   
              return(
                <LazyLoad height={"100%"} key={this.randomNum()}>
                  <img src={asset.url} className="image image--slickSlider"/>
                </LazyLoad>
              )} else {
              return(
                <LazyLoad height={"100%"} key={this.randomNum()}>
                  <video className="inline-video" playsInline autoPlay muted loop> <source src={asset.url} type="video/mp4" /> </video>
                </LazyLoad>
              )} 
            }.bind(this))
          } 
          </div>
        </div>
      )
    } else {
      return(null)
    } 
  } 
}

const mapStateToProps = (store) => {
  console.log('current project store', store.projectState.projectData)
  return {
    project: store.projectState.projectData
  };
};

export default connect(mapStateToProps)(ProjectPage);



/** WEBPACK FOOTER **
 ** ./src/js/views/projectPage/projectPage.js
 **/